<template>
	<div class="container">
		<h1 v-if="error.statusCode === 404">Pagina non trovata</h1>
		<div v-else-if="error.statusCode === 401">
			<h1>Accesso non consentito</h1>
			<nuxt-link class="link" to="/dashboard">Dashboard</nuxt-link>
		</div>
		<h1 v-else>Si è verificato un errore</h1>
	</div>
</template>

<script>
export default {
	props: {
		error: {
			type: Object,
			default: null,
		},
	},
	layout: 'auth',
};
</script>
